import React, { type CSSProperties } from 'react';

import parse, { Comment, Element, ProcessingInstruction, Text, domToReact } from 'html-react-parser';
import type { DOMNode, HTMLReactParserOptions } from 'html-react-parser';

interface Props {
  html: string;
}

const fullPageStyle: CSSProperties = {
  backgroundColor: 'rgb(255, 253, 211)',
  width: '210mm',
  minHeight: '297mm',
  marginLeft: '10px',
  marginRight: 'auto',
};

function isElementNode(domNode: DOMNode): domNode is Element {
  return domNode instanceof Element;
}

function isDomNode(domNode: Element['children'][number]): domNode is DOMNode {
  return (
    domNode instanceof Element ||
    domNode instanceof Text ||
    domNode instanceof Comment ||
    domNode instanceof ProcessingInstruction
  );
}

export default function AtolCertificate({ html }: Props) {
  const startBodyIndex = html.indexOf('<body');
  const endBodyIndex = html.indexOf('</body>') + 7;
  const body = html.slice(startBodyIndex, endBodyIndex);

  const options: HTMLReactParserOptions = {
    replace: (domNode) => {
      if (!isElementNode(domNode)) return undefined;

      if (domNode.attribs.class === 'em_body') {
        return <div>{domToReact(domNode.children.filter(isDomNode), options)}</div>;
      }

      return undefined;
    },
  };

  return (
    <div id="atol-certificate" style={fullPageStyle}>
      {parse(body, options)}
    </div>
  );
}
